<template>
  <div class="edit_nav_alias" v-if="showEdit">
    <div class="edit_box">
      <p class="title">自定义导航</p>
      <p class="item">
        <span>*</span>
        <span>名称</span>
      </p>
      <el-input class="" size="small" v-model="newConfig.menuName" @keyup.enter.native="confirm"></el-input>
      <p class="menu_group">
        <el-button size="small" @click="cancel">取消</el-button>
        <el-button size="small" type="primary" @click="confirm">确认</el-button>
      </p>
    </div>
  </div>

</template>

<script>
export default {
  name:'editNavAlias',
  props:{
    navConfig:{
      type:Object,
      default(){
        return {};
      }
    },
    showEdit:{
      type:Boolean,
      default:false
    }
  },
  watch:{
    navConfig(val){
      this.newConfig = JSON.parse(JSON.stringify(val));
    }
  },
  data(){
    return{
      newConfig:null,
    }
  },
  methods:{
    cancel(){
      this.newConfig = JSON.parse(JSON.stringify(this.navConfig));
      this.$emit('handleCancle');
    },
    confirm(){
      this.$emit('handleConfirm',this.newConfig);
    }
  }
}
</script>

<style lang="less">
  .edit_nav_alias{
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,.6);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    .edit_box{
      width: 370px;
      height: 210px;
      background: #fff;
      position: fixed;
      z-index: 1000;
      left: 50%;
      top: 50%;
      transform: translate(-50%,-50%);
      padding: 25px;
      box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
      overflow: hidden;
      backface-visibility: hidden;
      border: 1px solid #ebeef5;
      border-radius: 4px;
      p{
        margin: 0;
      }
      .title{
        font-size: 16px;
        color: #333;
        font-weight: 700;
      }
      .item{
        margin: 20px 0 10px 0;
        span{
          font-size: 14px;
          vertical-align: middle;
        }
        span:first-of-type{
          color: #f5222d;
        }
      }
      .menu_group{
        margin-top: 20px;
        text-align: right;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/editNavAlias.vue